import * as Yup from 'yup';

/* VALIDAÇÃO PARA EMPRESTIMOS PARA ATENDER EVENTOS */
export const SaidaEmprestimoEventoValidationSchema = Yup.object().shape({
	emprestimo: Yup.string().required('Campo obrigatório'),
	isEvento: Yup.string().required('Campo obrigatório'),
	id: Yup.string().required('Campo obrigatório'),
	ocorrencia: Yup.object().shape({ id: Yup.number().min(1, 'Campo obrigatório') }),
	quantidadeSaida: Yup.number().min(1, 'Quantidade não deve ser inferior a 1').required('Campo obrigatório'),
});

/* VALIDAÇÃO PARA EMPRESTIMOS PARA NÃO ATENDER EVENTOS */
export const SaidaEmprestimoNaoEventoValidationSchema = Yup.object().shape({
	emprestimo: Yup.string().required('Campo obrigatório'),
	isEvento: Yup.string().required('Campo obrigatório'),
	id: Yup.string().required('Campo obrigatório'),
	quantidadeSaida: Yup.number().min(1, 'Quantidade não deve ser inferior a 1').required('Campo obrigatório'),
	destinoEmprestimo: Yup.string().trim().required('Campo obrigatório'),
	motivo: Yup.string().trim().required('Campo obrigatório'),
	documento: Yup.string().nullable().required('Campo obrigatório'),
});

/* VALIDAÇÃO PARA DESCARTE */
export const SaidaEmprestimoDescarteValidationSchema = Yup.object().shape({
	emprestimo: Yup.string().required('Campo obrigatório'),
	id: Yup.string().required('Campo obrigatório'),
	quantidadeSaida: Yup.number().min(1, 'Quantidade não deve ser inferior a 1').required('Campo obrigatório'),
	motivo: Yup.string().trim().required('Campo obrigatório'),
});
